import { useState, useEffect, useCallback } from 'react';
import { authService } from '../services/authService';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authError, setAuthError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    const unsub = authService.onAuthChange((u) => {
      setUser(u);
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  const handleLogin = useCallback(async (email, password) => {
    setAuthError('');
    setLoginLoading(true);
    try {
      await authService.login(email, password);
    } catch {
      setAuthError('Invalid email or password.');
    }
    setLoginLoading(false);
  }, []);

  const handleLogout = useCallback(async () => {
    await authService.logout();
  }, []);

  return {
    user,
    authLoading,
    authError,
    loginLoading,
    handleLogin,
    handleLogout,
  };
}
